/** Fields a file column can be imported as, in the order of the ticket and the prototype. */
export const IMPORT_TARGET = Object.freeze({
  EMAIL: 'email',
  FIRST_NAME: 'first_name',
  LAST_NAME: 'last_name',
  FULL_NAME: 'full_name',
  JOB_TITLE: 'job_title',
  LOCATION: 'location',
  REPORTS_TO: 'reports_to',
  USER_TYPE: 'user_type',
  ROLES: 'roles',
  GROUPS: 'groups',
  SKIP: 'skip',
});

/** Targets in the order of the "Imports as" dropdown; `labelKey` is under `people-access`. */
export const IMPORT_TARGETS = Object.freeze(
  Object.values(IMPORT_TARGET).map((id) => ({ id, labelKey: `import.match.targets.${id}` })),
);
